const mutations = {
  updateDocs: (state, payload) => {
    state.pfDocs = payload
  },
  updatePfDocsSection: (state, payload) => {
    state.pfDocsSection = payload
  },
  updatePfCandidates: (state, payload) => {
    state.pfCandidates = payload
  },
  updateCurrPage: (state, payload) => {
    state.currPage = payload
  },
  updateActivityCount: (state, payload) => {
    state.pfActivityCount = payload
  },
  updatePageCount: (state, payload) => {
    state.pageCount = payload
  },
}

export default mutations
